import 'css-chunk:src/components/MiniItem.module.scss';export default {
  "mini": "_mini_1dp43_1",
  "placeholder": "_placeholder_1dp43_9",
  "name": "_name_1dp43_15"
};